import { render, staticRenderFns } from "./planFundList.vue?vue&type=template&id=06b30387"
import script from "./planFundList.vue?vue&type=script&lang=js"
export * from "./planFundList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports